export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.onConsent = () => {
    if (typeof useHotjar === 'function') {
      const { initialize } = useHotjar()
      initialize()
    }
  }
})
